module.exports = __webpack_public_path__ + "5623d0906e51c0226f0aa675d44ae74e.png";